import { ref } from "vue";

import useAuthApi from "@/composables/useAuthApi";
import { useAuthStore } from "@/stores/useAuthStore";

export default function UseCalaUser() {
  const loading = ref<boolean>(false);
  const error = ref<any>();

  const authApi = useAuthApi();
  const { logOut } = useAuthStore();
  async function getCalaUser(): Promise<any> {
    try {
      const result = await authApi.get("api/userInfo/getUser/");
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  async function updateCalaUser(payload: any): Promise<void> {
    try {
      const result = await authApi.postJson(
        "api/userInfo/postUser/",
        payload
      );
      // setUserInfo(result.data);
    } catch (error: any) {
      if (error?.response?.status === 401) {
        logOut();
      }
      throw error;
    }
  }

  async function wontRegisterCalaUser(payload: string): Promise<any> {
    try {
      const result = await authApi.postJson(
        "api/userInfo/wontRegister/",
        payload
      );
      return result;
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  }

  return {
    // action
    getCalaUser,
    updateCalaUser,
    wontRegisterCalaUser,

    // state
    loading,
    error
  };
}
